import * as actions from '../../../actions/assessments/budget'
import * as h2Api from '../../../h2Api'

const initialState = {
  selectedZipCode: null,
  locations: h2Api.handleRest()
}
const location = (state = initialState, action) => {
  switch (action.type) {
    case actions.LOAD_LOCATIONS:
      return {
        ...state,
        locations: h2Api.handleRest(action)
      }

    default:
      return state
  }
}

export default location
